module.exports = "/packs/images/better_logo~8c9fcd6e31270cee7b2bd0734e9d5606.png";